<template>
  <button
    type="button"
    class="inline-flex items-center px-2 py-1 text-sm font-medium 
    text-skin-b-list-base bg-skin-b-list-back border-l-2 border-y-2 border-skin-b-list-bord  
    focus:z-10 focus:ring-0 focus:ring-transparent focus:text-skin-b-base"
    :class="{'rounded-l-md' : border=='left',
              'border-r-2 rounded-r-md' : border=='right',
              'border-r-2 border-transparent' : border=='all',
              'hover:text-skin-b-base hover:bg-skin-b-back' : hovercolor=='',
              'hover:text-red-800 hover:bg-red-100' : hovercolor=='red',
              'hover:text-green-800 hover:bg-green-100' : hovercolor=='green',
    }">
    <slot></slot>
  </button>
</template>
 <script>
 export default {
   props: {
     border: {
       type: String,
       default: ''
     },
     hovercolor: {
       type: String,
       default: ''
     }
   }
 };
 </script>